/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostslistpricenote4Inputs */

const en_aicostslistpricenote4 = /** @type {(inputs: Aicostslistpricenote4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider list prices in US dollars. Credits count only what stayed paid after refunds; free features have no credits.`)
};

const de_aicostslistpricenote4 = /** @type {(inputs: Aicostslistpricenote4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listenpreise der Anbieter in US-Dollar. Credits zählen nur, was nach Rückbuchungen bezahlt blieb; kostenlose Funktionen haben keine Credits.`)
};

/**
* | output |
* | --- |
* | "Provider list prices in US dollars. Credits count only what stayed paid after refunds; free features have no credits." |
*
* @param {Aicostslistpricenote4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostslistpricenote4 = /** @type {((inputs?: Aicostslistpricenote4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostslistpricenote4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostslistpricenote4(inputs)
	return de_aicostslistpricenote4(inputs)
});
export { aicostslistpricenote4 as "aiCostsListPriceNote" }